import './css/loaders.css'

export default function Loader1({ accountType }) {
    return (
        <div
            className={accountType === "celebrity" ? "loader loader-celebrity" : "loader"}
        ></div>
    )
}